import { css } from '@emotion/react';
import COLORS from 'shared/styles/colors';
import theme from 'shared/styles/themes';

export default css({
  '&.brand-full-brief-view': {
    backgroundColor: COLORS.WHITE,
    height: '100%',
    flex: 1,
    overflowY: 'scroll',
    padding: theme.space[5],

    '& .brand-full-brief-view__heading p': {
      height: '32px',
      marginBottom: theme.space[4],
      fontSize: theme.fontSizes[5],
    },
    '& .brand-full-brief-view__detail': {
      marginBottom: '1.25rem',
    },
  },
  '.brand-full-brief-view': {
    '&__info-icon': {
      minWidth: 'unset',
      width: 'fit-content',
      marginLeft: theme.space[2],
      padding: 0,
    },
    '&__toggle-with-info': {
      alignItems: 'center',
      marginBottom: theme.space[3],
    },
    '&__module-tabs': {
      marginBottom: '1.25rem',
    },
    '&__module-tab': {
      marginRight: theme.space[3],
    },
    '&__toggle-with-info + .brand-full-brief-view__detail, &__product-links + .brand-full-brief-view__shipping-required':
      {
        marginTop: '1.25rem',
      },
  },
});
